import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

function toMs(t: Date | number | string | undefined | null): number {
    if (t == null) return NaN;
    if (typeof t === "number") return t;
    if (t instanceof Date) return t.getTime();
    const ms = Date.parse(t);
    return Number.isNaN(ms) ? NaN : ms;
}

export function diffMs(start: Date | number | string, end: Date | number | string) {
    return toMs(end) - toMs(start);
}

// "m m s s"
export function formatDuration(ms: number) {
    if (!Number.isFinite(ms)) {
        return "";
    }

    const s = Math.floor(ms / 1000);

    const mm = Math.floor(s / 60);
    const minutesStringed = mm > 0 ? `${mm}m` : "";

    const ss = s % 60;
    const secondsStringed = ss > 0 ? `${ss}s` : "";
    return `${minutesStringed} ${secondsStringed}`;
}
